$('.collection_image_menu_section').hide();

$('.collection_image_menu_holder').hide();

$(".sub-sub-menu li").mouseenter(function(){

if($(this).find('a').attr('id') == 0) {


} else {

$('.collection_image_menu_section').show();


var test = $(this).find('a').attr('id') ;

$('.menu_image_area .gl_carousel_container').hide();

$('.collection_image_menu_holder-'+test).show();

}



});

$(".sub-sub-menu li").mouseleave(function(){
$('.menu_image_area .gl_carousel_container').show();
$('.collection_image_menu_section').hide();

if($(this).find('a').attr('id') == 0) {


} else {
var test2 = $(this).find('a').attr('id') ;

$('.collection_image_menu_holder-'+test2).hide();
}
});



$('.acc-widget-title').click(function(){
    $(this).nextAll('.textwidget').toggle();
    $(this).find('span').html() == '<i class="fas fa-minus"></i>' ? $(this).find('span').html('<i class="fas fa-plus"></i>') : $(this).find('span').html('<i class="fas fa-minus"></i>');
});







$('.footer-widget').find('a').each(function() {
	var link = $(this).attr('href');
	if(link == '#distributor-login') {
		$(this).closest("li").attr('id','dist-login');
	}
	if(link == '#newsletter-popup') {
		$(this).closest("li").attr('id','news-pop');
	}
});

$(document).ready(function(){
	$('#dist-login a').click(function (event) {
	  	event.preventDefault();
$('.login-side-opener').trigger('click');
	});

	$('#news-pop a').click(function (event) {
	  	event.preventDefault();
$.cookie('basel_popup_1', null);		
$('.basel-open-popup').trigger('click');
	});
});



$(document).on('click', '.readmore_product_button', function (event) {
    event.preventDefault();
    $('html, body').animate({
        scrollTop: $($.attr(this, 'href')).offset().top + -130
    }, 1000);
	
$('li.description_tab a').trigger('click');


});